// extracted by mini-css-extract-plugin
export default {"userBadges":"UserBadge_userBadges__Ax-o7","badge":"UserBadge_badge__VchLu","verified":"UserBadge_verified__BTRce","topSeller":"UserBadge_topSeller__hGUoS"};